(function () {
  var selector = 'img[data-eyesnug-article-image]';
  var observer = null;

  function hydrate(image) {
    if (!image || !image.matches(selector)) return;

    var srcset = image.getAttribute('data-srcset');
    var src = image.getAttribute('data-src');
    if (srcset) image.setAttribute('srcset', srcset);
    if (src) image.setAttribute('src', src);
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');
    image.removeAttribute('data-eyesnug-article-image');
    if (observer) observer.unobserve(image);
  }

  function observe(image) {
    if (!image || !image.matches(selector)) return;
    if (!('IntersectionObserver' in window)) {
      hydrate(image);
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) hydrate(entry.target);
        });
      }, { rootMargin: '300px 0px', threshold: 0.01 });
    }
    observer.observe(image);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(selector).forEach(observe);
  }

  function hydrateFromIntent(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var card = target.closest('.article');
    if (card) hydrate(card.querySelector(selector));
  }

  document.addEventListener('pointerover', hydrateFromIntent, { passive: true });
  document.addEventListener('touchstart', hydrateFromIntent, { passive: true });
  document.addEventListener('focusin', hydrateFromIntent);
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  var grid = document.querySelector('.load-more-grid');
  if (grid && 'MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.matches(selector)) observe(node);
          init(node);
        });
      });
    }).observe(grid, { childList: true, subtree: true });
  }
})();
